import { render, staticRenderFns } from "./category.vue?vue&type=template&id=74183132&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=74183132&prod&lang=scss&scoped=true"
import style1 from "./category.vue?vue&type=style&index=1&id=74183132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74183132",
  null
  
)

export default component.exports